/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PurRtnSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const purRtnSync01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const purRtnSync01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const purRtnSync01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const purRtnSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PurRtnSync01Types.PUR_RTN_SYNC01_SHOW_SYNC_SETTING_LOADING]: purRtnSync01ShowSyncSettingLoading,
  [PurRtnSync01Types.PUR_RTN_SYNC01_SHOW_SYNC_SETTING_SUCCESS]: purRtnSync01ShowSyncSettingSuccess,
  [PurRtnSync01Types.PUR_RTN_SYNC01_SHOW_BATCH_JOB_STATUS_SUCCESS]: purRtnSync01ShowBatchJobStatusSuccess,
  [PurRtnSync01Types.PUR_RTN_SYNC01_SYNC_LOADING]: purRtnSync01SyncLoading
});
